import React, { useState } from "react";

import { AnimatePresence } from "framer-motion";

import { ReactComponent as IconPlus } from "../../assets/icons/icon_plus.svg";
import { faqData } from "../../config/faqData";

import {
  AccordionContainer,
  AccordionItem,
  AnswerContainer,
  AnswerContent,
  Circle,
  Container,
  QuestionButton,
  TextWithLink,
  Title,
  TitleBlock,
  ToggleIcon,
} from "./styles";

type FAQItem = {
  title: string;
  desc: string;
};

type FAQSectionProps = {
  data?: FAQItem[];
  pageKey?: keyof typeof faqData;
  items?: FAQItem[];
  title?: string;
  desc?: string;
};

export const FAQSection: React.FC<FAQSectionProps> = ({
  data,
  pageKey = "career_consult_page",
  items,
  title,
  desc
}) => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems(prev =>
      prev.includes(index)
        ? prev.filter(item => item !== index)
        : [...prev, index]
    );
  };

  const singleItem = title && desc ? [{ title, desc }] : undefined;

  const faqItems = data || items || singleItem || faqData[pageKey] || [];

  return (
    <Container>
      <TitleBlock>
        <Title>Часто задаваемые вопросы</Title>
        <TextWithLink>
           Что-то еще? Напишите нам в
          <a
            href="https://t.me/ProhorovaConsult"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: 5 }}
          >
            Telegram
          </a>
        </TextWithLink>
      </TitleBlock>
      <AccordionContainer>
        {faqItems.map((item, index) => (
          <AccordionItem key={index}>
            <QuestionButton onClick={() => toggleItem(index)}>
              <Circle />
              <span style={{ flex: 1 }}>{item.title}</span>
              <ToggleIcon active={openItems.includes(index)}>
                <IconPlus />
              </ToggleIcon>
            </QuestionButton>

            <AnimatePresence initial={false}>
              {openItems.includes(index) && (
                <AnswerContainer
                  key={`faq-${index}-content`}
                  initial={{ height: 0, opacity: 0, marginTop: 0 }}
                  animate={{ height: "auto", opacity: 1, marginTop: 14 }}
                  exit={{ height: 0, opacity: 0, marginTop: 0 }}
                  transition={{ type: "tween", duration: 0.25 }}
                >
                  <AnswerContent>
                    {item.desc}
                  </AnswerContent>
                </AnswerContainer>
              )}
            </AnimatePresence>
          </AccordionItem>
        ))}
      </AccordionContainer>
    </Container>
  );
}
